module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "doc"
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "doc-nav"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "#/doc"
    }
  }, [_vm._v("Documentation")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://github.com/hust220/nsp"
    }
  }, [_vm._v("Github")])]), _vm._v(" "), _c('ul', _vm._l((_vm.doc_nav), function(theme) {
    return _c('li', {
      staticClass: "doc-theme"
    }, [_c('strong', [_c('a', {
      class: [theme.href == '#' + _vm.$route.path ? 'active' : ''],
      attrs: {
        "href": theme.href
      },
      domProps: {
        "textContent": _vm._s(theme.text)
      }
    })]), _vm._v(" "), _c('ul', _vm._l((theme.items), function(item) {
      return _c('li', {
        staticClass: "doc-item"
      }, [_c('a', {
        class: [item.href == '#' + _vm.$route.path ? 'active' : ''],
        attrs: {
          "href": item.href
        },
        domProps: {
          "textContent": _vm._s(item.text)
        }
      })])
    }))])
  }))])]), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 18,
      "offset": 6
    }
  }, [_c('div', {
    staticClass: "doc-content",
    style: ('padding-bottom: ' + _vm.padding_bottom + 'px'),
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c80a8c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doc.vue
// module id = 86
// module chunks = 2